import securityNew from './security/securityReducer';
import global from './global/globalReducer';
import sidebar from './sidebar/sidebarReducer';
import sonarDashboard from './sonar/sonarReducer';
import userManagement from './user-management/userManagementReducer';
import projects from './projects/projectsReducer';
import notifier from './notifier/notifierReducer';
import scout from './scout/scoutReducer';
import scoutSettings from './settings/scout/scoutSettingsReducer';
import consumer from './consumer/consumerReducer';
import customers from './customers/customersReducer';
import createSonar from './create-sonar/createSonarReducer';
import sonarManagement from './sonar-management/sonarManagementReducer';
import aiPlayground from './ai-playground/aiPlaygroundReducer';
import resonance from './resonance/resonanceReducer';
import genie from './genie/genieReducer';
import genieGo from './genie-go/genieGoReducer';
import id8 from './id8/id8Reducer';
import id8Settings from './settings/id8/Id8SettingsReducer';
import activ8Settings from './settings/activ8/activ8SettingsReducer';
import demoRecreate from './demo-recreate/demoRecreateReducer';
import activ8 from './activ8/activ8Reducer';
import aiStudio from './ai-studio/aiStudioReducer';
import story from './story/storyReducer';
import activ8Messages from './activ8/activ8MessagesReducer';

export default {
  sidebar,
  global,
  sonarDashboard,
  securityNew,
  userManagement,
  projects,
  notifier,
  scout,
  scoutSettings,
  consumer,
  customers,
  createSonar,
  sonarManagement,
  aiPlayground,
  resonance,
  genie,
  genieGo,
  id8,
  id8Settings,
  activ8Settings,
  demoRecreate,
  activ8,
  aiStudio,
  story,
  activ8Messages,
};
